import { render, staticRenderFns } from "./customer-vehicle-mileage-history.vue?vue&type=template&id=0b4dcd01&"
import script from "./customer-vehicle-mileage-history.vue?vue&type=script&lang=js&"
export * from "./customer-vehicle-mileage-history.vue?vue&type=script&lang=js&"
import style0 from "./customer-vehicle-mileage-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports